'use client';

import { useSubsidiaryFilterOptional } from '@/@subsidiary/context';

/**
 * Whether a staff member is viewing as a client in this tab (M4S-5670 §5).
 * Surfaces use it to show the client's view: no internal Delete/Publish, no
 * hidden questions, read-only Team, and so on. False outside the provider and
 * for client users in a hierarchy, whose org switcher is not View-as.
 */
export function useIsViewingAsClient(): boolean {
    const filter = useSubsidiaryFilterOptional();
    return filter != null && filter.isInternal && filter.masqueradeOrgId != null;
}

/** The name of the client being viewed as, or null. */
export function useViewAsClientName(): string | null {
    const filter = useSubsidiaryFilterOptional();
    if (!filter || !filter.isInternal || filter.masqueradeOrgId == null) return null;
    return filter.viewAsOrgName;
}
